import { getTranslations } from '../../api/translations-api';
import { apiCallError, beginApiCall } from '../api/api-status-action';
import { LOAD_SESSION_ERROR } from '../session/session-actions';

export const LOAD_TRANSLATIONS_SUCCESS = 'LOAD_TRANSLATIONS_SUCCESS';
export const LOAD_TRANSLATIONS_ERROR = 'LOAD_TRANSLATIONS_ERROR';

// Actions
export const loadTranslationsError = (error: any) => ({
    type: LOAD_SESSION_ERROR,
    result: error,
});

export const loadTranslationsSuccess = (translations: object) => ({
    type: LOAD_TRANSLATIONS_SUCCESS,
    translations,
});

// Thunks
export const loadTranslations = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('LOAD_TRANSLATIONS'));
            const translations = await getTranslations();
            dispatch(loadTranslationsSuccess(translations));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
